import { Button as AntdButton } from 'antd';
import styled from 'styled-components';

export const Button = styled(AntdButton)`
  height: 60px;
  margin: 0;
`;
